<script>
    export let content;

    import { Link } from 'svelte-navigator'
    import Button from '../common/Button.svelte';
    import { getURL } from '../../utils/functions'

    const title = content.title;
    const text = content.text;
    const email = content.email;

    let inputName = '';
    let inputEmail = '';
    let inputSubject = '';
    let inputMessage = '';

    let inputNameElement;
    let inputEmailElement;
    let inputSubjectElement;
    let inputMessageElement;
    let inputGDPRElement;

    let status = '';

    const sendEmail = async () => {
        if (validateForm()) {
            const data = {
                name: inputName,
                email: inputEmail,
                subject: inputSubject,
                message: inputMessage
            }

            const response = await fetch(getURL('/messages'), {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(data)
            })
            .then(res => {
                status = 'success';
                clearForm();
            })
            .catch(error => status = 'fail')
            
            return response.json();
        } else {
            status = 'validate';
        }
    };

    const clearForm = () => {
        inputName = '';
        inputEmail = '';
        inputSubject = '';
        inputMessage = '';
    };

    const validateForm = () => {
        return inputNameElement.checkValidity() && inputEmailElement.checkValidity() && inputSubjectElement.checkValidity() && inputMessageElement.checkValidity() && inputGDPRElement.checkValidity();
    }
    
</script>

<!-- Begin of contact section -->
<div class="section section-contact section-cent fp-auto-height-responsive hide-clock bg-primary" data-section="contact">
    
    <!-- begin of information slide -->
    <div class="slide" id="information" data-anchor="information">
        <section class="content clearfix">
            <!-- Begin of Content -->
            <div class="content-contact c-columns fit">
                <div class="row wrapper">
                    <div class="columns small-12 medium-12 large-12">
                        <div class="col-wrapper anim">
                            <!-- title -->
                            <header class="title-desc">
                                <span class="anim-wrapper">
                                    <h2 class="page-title">{title}</h2>
                                </span>
                                <span class="anim-wrapper">
                                    <p>{text}</p>
                                </span>
                            </header>

                            <!-- Begin of contact list -->
                            <ul class="contact-list c-features row small-up-1 medium-up-2 large-up-2">
                                <!-- item -->
                                <li class="column anim">
                                    <div class="item-desc">
                                        <span class="anim-wrapper">
                                            <h3 class="title">Contact</h3>
                                        </span>
                                        <div class="desc">
                                            <span class="anim-wrapper">
                                                <p>
                                                    Email : <a href={`mailto:${email}`}>{email}</a>
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <!-- End of contact list -->

                            <!-- Action button -->
                            <Button link='#contact/message'>Send a Message</Button>

                        </div>
                    </div>
                </div>
            </div>
            <!-- End of Content -->
        </section>
    </div>
    <!-- end of information slide -->

    
    <!-- begin of message slide -->
    <div class="slide" id="message" data-anchor="message">
        <section class="content clearfix">
            <!-- Begin of Content -->
            <div class="content-contact c-columns fit">
                <div class="row wrapper">
                    <div class="columns small-12 medium-12 large-12">
                        <div class="centered">
                            <div class="title-desc">
                                <h2 class="page-title">Write to Us</h2>
                                <p>Have a question or just want to leave a message?</p>
                            </div>

                            <div class="c-form">
                                <!-- begin of contact form content -->
                                <div class="c-content card-wrapper">
                                    <form class="message form send_message_form" id="message_form">
                                        <div class="fields clearfix no-border">
                                            <div class="input name">
                                                <label for="mes-name">Name :</label>
                                                <input id="mes-name" name="name" type="text" placeholder="" class="form-success-clean" required bind:value={inputName} bind:this={inputNameElement}>
                                            </div>
                                        </div>
                                        <div class="fields clearfix no-border">
                                            <div class="input email">
                                                <label for="mes-email">Email :</label>
                                                <input id="mes-email" type="email" placeholder="" name="email" class="form-success-clean" required bind:value={inputEmail} bind:this={inputEmailElement}>
                                            </div>
                                        </div>
                                        <div class="fields clearfix no-border">
                                            <div class="input last">
                                                <label for="mes-email">Subject :</label>
                                                <input id="mes-email" type="text" placeholder="" name="subject" class="form-success-clean" required bind:value={inputSubject} bind:this={inputSubjectElement}>
                                            </div>
                                        </div>
                                        <div class="fields clearfix no-border">
                                            <label for="mes-text">Message</label>
                                            <textarea id="mes-text" placeholder="..." name="message" class="form-success-clean" required bind:value={inputMessage} bind:this={inputMessageElement}></textarea>
                                        </div>

                                        <div class="gdpr clearfix">
                                            <input id="gdpr-contact" class="input" type="checkbox" required bind:this={inputGDPRElement}>
                                            <label for="gdpr-contact">By using this contact form, you agree to our <a href="/privacy-policy" target="_blank">Terms and privacy policy</a>.</label>
                                        </div>

                                        <div>
                                            {#if status === 'success'}
                                            <p class="message-ok form-text-feedback form-success-visible">Your message has been sent, thank you.</p>
                                            {:else if status === 'fail'}
                                            <p class="message-ok form-text-feedback form-success-visible">Something went wrong, unable to send message.</p>
                                            {:else if status === 'validate'}
                                            <p class="message-ok form-text-feedback form-success-visible">Please fill out all the fields.</p>
                                            {/if}
                                        </div>

                                        <div class="btns">
                                            <button type='button' id="submit-message" class="btn btn-normal email_b" name="submit_message" on:click={sendEmail}>
                                                <span class="txt">Send</span>
                                                <span class="arrow-icon"></span>
                                            </button>
                                            
                                            <a class="btn btn-normal" href="#contact/information" on:click={() => status = ''}>
                                                <span class="txt">information</span>
                                                <span class="arrow-icon"></span>
                                            </a>
                                        </div>
                                    </form>

                                    <!-- Action button -->
                                    <div class="cta-btns">
                                    </div>

                                </div>
                                <!-- end of contact form content -->
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- End of content -->
        </section>
    </div>
    <!-- end of message slide -->
</div>
<!-- End of contact section -->